class SingleProducerMeeting {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/single-producer-meeting`;
    this.apiClient = apiClient;

  }

  async createOrGetSingleProducerMeetingByOwnerIdAndPostId(postId) {

    const path = this.basePath;

    return this.apiClient.post(path, { postId }, {}, {});

  }

  async canAllowEventStreamingMinutesMetric() {

    const path = `${this.basePath}/available`;

    return this.apiClient.get(path, {}, {}, {});

  }

  async getSingleProducerMeetingByPostId(postId) {

    const path = this.basePath;

    return this.apiClient.get(path, { postId });

  }

  async startSingleProducerMeetingByPostId(postId) {

    const path = `${this.basePath}/start`;

    return this.apiClient.put(path, { postId }, {}, {});

  }

  async endSingleProducerMeetingByPostId(postId) {

    const path = `${this.basePath}/end`;

    return this.apiClient.put(path, { postId }, {}, {});

  }

  async muteSingleProducerMeetingByPostId(postId) {

    const path = `${this.basePath}/mute-all`;

    return this.apiClient.put(path, { postId }, {}, {});

  }

  async unmuteSingleProducerMeetingByPostId(postId) {

    const path = `${this.basePath}/unmute-all`;

    return this.apiClient.put(path, { postId }, {}, {});

  }

  async updateSingleProducerMeetingHostVideoSettingsByPostId(postId, videoSettings) {

    const path = `${this.basePath}/host-video-settings`;

    return this.apiClient.put(path, { postId }, {}, videoSettings);

  }

  async recordSingleProducerMeetingByPostId(postId, partDetails) {

    const path = `${this.basePath}/record`;

    return this.apiClient.put(path, { postId }, {}, partDetails);

  }

  async trySetMeetingLiveStatusToConnected(postId, browserWindowId) {

    const path = `${this.basePath}/connect`;

    return this.apiClient.put(path, { postId }, {}, { browserWindowId });

  }

  async createOrGetSingleProducerMeetingAttendeeByPostIdAndAttendeeId(postId, meetingId) {

    const path = `${this.basePath}/:meetingId/attendees`;

    return this.apiClient.post(path, { postId, meetingId }, {}, {});

  }

  async deleteSingleProducerMeetingAttendeeByPostIdAndAttendeeId(postId, meetingId, attendeeId) {

    const path = `${this.basePath}/:meetingId/attendees/:attendeeId`;

    return this.apiClient.post(path, { postId, meetingId, attendeeId }, {}, {});

  }

}

export default SingleProducerMeeting;